import type { ActionHandler } from '../types';
import { invokeSemanticPort, readString } from './helpers';

export const dismissExperienceHandler: ActionHandler = {
  type: 'dismiss_experience',
  execute(ctx) {
    const config = ctx.config;
    const port = ctx.semanticPorts?.dismissExperience;
    return invokeSemanticPort(
      ctx,
      'dismiss_experience',
      port
        ? (context) =>
            port(
              {
                experienceId: readString(config, 'experienceId', 'experience_id'),
                targetBlockId: ctx.intentEnvelope?.payload.context.blockId,
              },
              context
            )
        : undefined
    );
  },
};
